import { Timestamp } from '../datetime';

export enum MetaChannel {
  WHATSAPP = 'WHATSAPP',
  MESSENGER = 'MESSENGER',
  INSTAGRAM = 'INSTAGRAM',
}

export interface PhoneNumber {
  readonly name?: string;
  readonly phoneNumber?: string;
  readonly phoneNumberId: string;
  readonly isActive?: boolean;
  readonly isFetched?: boolean;
  readonly businessAccountId: string;
  readonly externalId: string;
}

export interface MetaAccount {
  readonly id?: string;
  readonly channel: MetaChannel;
  readonly name: string;
  readonly tenantId: string;
  readonly businessAccountId: string;
  readonly isDisabled: boolean;
  readonly accessToken?: string;
  readonly webhookVerifyToken?: string;
  readonly createdAt: Timestamp;
  readonly updatedAt: Timestamp;
  readonly appId: string;
  readonly metaAppId: string;
  readonly status?: string;
  readonly phoneNumbers?: PhoneNumber[];
}

export interface WhatsappAccountConfig {
  readonly featureFlags: {
    readonly ACTIVE: boolean;
    readonly CAMPAIGN: boolean;
    readonly ONE_TO_ONE: boolean;
  }
}

export interface MetaEmbedSignup {
  readonly code: string;
  readonly phoneNumberId: string;
  readonly wabaId: string;
  readonly businessId: string;
  readonly appId: string;
}